import React from 'react';

import { TextButton } from '@fragment/ui/src/components/Button/TextButton/TextButton';
import { Icon } from '@fragment/ui/src/components/Icon';

export type SettingsModalLayoutProps = {
  title: string;
  children: React.ReactNode;
  onBackButtonClick?: () => void;
  onSubmit?: () => void;
  topButtonSection?: React.ReactNode;
  bottomButtonSection?: React.ReactNode;
  hideHeader?: boolean;
};

const Wrapper = ({
  children,
  onSubmit,
}: {
  children: React.ReactNode;
  onSubmit?: () => void;
}) =>
  onSubmit ? (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      {children}
    </form>
  ) : (
    <>{children}</>
  );

export const SettingsModalLayout = ({
  children,
  title,
  topButtonSection,
  bottomButtonSection,
  onBackButtonClick,
  onSubmit,
  hideHeader = false,
}: SettingsModalLayoutProps) => (
  <Wrapper onSubmit={onSubmit}>
    <div
      className="flex flex-col space-y-f4 w-full h-full"
      data-testid="settings-modal-layout"
    >
      {!hideHeader && (
        <div className="flex justify-between h-fit">
          {onBackButtonClick ? (
            <TextButton onClick={onBackButtonClick}>
              <div className="flex space-x-[1ch] items-center">
                <Icon type="left" size="md" />
                <span>Back</span>
              </div>
            </TextButton>
          ) : (
            <span>{title}</span>
          )}
          {topButtonSection}
        </div>
      )}
      {children}
      <div className="flex w-full h-fit">{bottomButtonSection}</div>
    </div>
  </Wrapper>
);
